<template>
  <Modal
    :mask-closable="false"
    :closable="false"
    title="手动充值"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="选择代理商:" prop="agentName">
            <Select
              v-model.trim="handleForm.agentName"
              filterable
              remote
              clearable
              :remote-method="getAgent"
              :loading="commodityLoading"
              @on-select="selectAgent"
              @on-query-change="changeAgent">
              <Option v-for="(option, index) in agentList" :value="option.id" :key="index" >{{option.agentName}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24" v-if="handleForm.agentName">
          <FormItem label="选择商品:" prop="agentCommodityId" >
            <Select
              v-model.trim="handleForm.agentCommodityId"
              filterable
              remote
              clearable
              :loading="commodityLoading">
              <Option v-for="(option, index) in commodityOptions" :value="option.id" :key="index">{{option.commodityName}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="用户账号:" prop="account">
            <Input v-model.trim="handleForm.account" placeholder="请输入" maxlength="100" />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="代理商编号:" prop="agentId">
            <Input v-model.trim="handleForm.agentId" placeholder="请输入" maxlength="100" />
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">充值</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'

export default {
  name: 'ManualRecharge',
  data () {
    return {
      modal: false,
      loading: false,
      commodityLoading: false,
      commodityOptions: [],
      handleForm: {
        agentName: '',
        agentCommodityId: '',
        account: '',
        agentId: ''
      },
      handleValidate: {
        agentName: [
          { required: true, whitespace: true, message: '请选择代理商', trigger: 'change' }
        ],
        agentCommodityId: [
          { required: true, whitespace: true, message: '请选择充值的商品', trigger: 'change' }
        ],
        account: [
          { required: true, whitespace: true, message: '请输入用户账号', trigger: 'blur' }
        ]
      },
      // 代理商
      agentName: '',
      agentList: []
    }
  },
  methods: {
    show () {
      this.modal = true
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {
        ...this.handleForm
      }
      this.loading = true
      delete queryParams.agentName
      delete queryParams.agentId
      api.recharge.manualRecharge(queryParams).then(() => {
        this.$emit('success')
        this.$Message.success('手动充值成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error('手动充值失败：' + err.message)
      }).then(() => {
        this.loading = false
      })
    },
    commodityQuery (query) {
      if (query !== '') {
        this.commodityLoading = true
        // TODO: 搜索商品
        api.commodity.commodityList({
          pageNum: 1,
          pageSize: 100
        }).then(res => {
          const result = res.data.records || []
          result.map(item => {
            this.commodityOptions.push({
              value: item.id,
              label: item.commodityName
            })
          })
        }).catch(() => {
          // tips
          this.commodityOptions = []
        }).then(() => {
          this.commodityLoading = false
        })
      }
    },
    getAgentList (val) {
      api.agent.agentList({
        pageNum: 1,
        pageSize: 999,
        agentName: val
      }).then(res => {
        this.agentList = res.data.records
      }).catch(err => {
        this.$Message.error('获取商户列表失败：' + err.message)
      })
    },
    queryAgentCommodities (agentId) {
      api.agent.agentCommodityList({
        agentId: agentId,
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        this.commodityOptions = res.data.records
      }).catch(err => {
        this.$Message.error('获取商户商品失败：' + err.message)
      })
    },
    // 选中商户
    selectAgent (val) {
      this.selectAgentId = val.value
      this.queryAgentCommodities(val.value)
      this.handleForm.agentCommodityId = ''
    },
    // 改变商户输入框
    changeAgent (val) {
      this.throttle(this.getAgentList, 500, val)
    },
    // 远程获取商户
    getAgent () {
      this.throttle(this.getAgentList, 500)
    },
    throttle (fn, delay, val) {
      clearTimeout(fn.timeoutId)
      fn.timeoutId = setTimeout(function () {
        fn.call(val)
      }, delay)
    }
  },
  mounted () {
    this.getAgentList()
  }
}
</script>
